import { Typography } from "@mui/material"
import { ReactElement } from "react"

import {
    AppAccordion,
    AppAccordionDetails,
    AppAccordionSummary,
} from "../../dataDisplay/accordions/appAccordions"
import NestedVerticalKeyValueList from "../../dataDisplay/nestedVerticalKeyValueList"

interface INestedDetailListAccordionProps {
    title: string
    kwargs: Record<string, Record<string, string | number | boolean | null>>
    defaultExpanded?: boolean
}

/**
 * Uncontrolled accordion component which displays a list of nested key value pairs.
 */
const NestedDetailListAccordion = ({
    title,
    kwargs,
    defaultExpanded,
}: INestedDetailListAccordionProps): ReactElement => (
    <AppAccordion defaultExpanded={defaultExpanded}>
        <AppAccordionSummary>
            <Typography fontWeight="500">{title}</Typography>
        </AppAccordionSummary>
        <AppAccordionDetails>
            <NestedVerticalKeyValueList
                nestedKwargs={kwargs}
                headerVairant="h6"
            />
        </AppAccordionDetails>
    </AppAccordion>
)
NestedDetailListAccordion.defaultProps = {
    defaultExpanded: false,
}

export default NestedDetailListAccordion
